import BasicModal from 'components/Modal'
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import SoftInput from 'components/SoftInput'
import SoftTypography from 'components/SoftTypography'
import React from 'react'

const CustomDate = ({ show, setShow, startDate, endDate, setEndDate,setStartDate,setDateValue }) => {
  
  const handleSubmit = () => {  
    setShow(false)
    setDateValue('Custom');
  }
  
  return (
    <BasicModal show={show} unShow={setShow}   text="Custom Date">
      <SoftTypography variant="h6" fontWeight="medium" sx={{ mt: 2 }}>
        Select Date Range
      </SoftTypography>
      <SoftBox sx={{ display: 'flex', gap: 2, mt: 5 }}>
        <SoftInput label="Start Date" type="date" value={startDate}
          onChange={(e) => {
            setStartDate(e.target.value)
          }}
        />
        <SoftInput label="End Date" type="date" value={endDate}
        fullWidth
          onChange={(e) => {
            setEndDate(e.target.value)
          }}
        />
      </SoftBox>
      <SoftBox sx={{ display: 'flex', mt: 4 }}>
        <SoftButton
        fullWidth
          variant="gradient"
          color="info"
          sx={{ color: 'white'}}
          onClick={handleSubmit}
        >
          Submit
        </SoftButton>
      </SoftBox>

    </BasicModal>
  )
}

export default CustomDate